<template>
    <div id="followPopover">
        <v-popover :open="open" :auto-hide="false" placement="left">
            <template slot="popover">
                <h5>Follow questions to get notifications about new answers</h5>
                <button class="btn btnRed btnSm" @click="close">
                    Ok, got it!
                </button>
            </template>
        </v-popover>
    </div>
</template>
<script>
    import BasePopover from './BasePopover'
    import { VPopover } from "v-tooltip"

    export default {
        name: 'FollowPopover',
        extends: BasePopover,
        components: {
            VPopover
        }
    }
</script>